'use client';
import React from 'react';
import { Toaster } from 'sonner';

export default function ToastProvider() {
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          fontFamily: 'var(--font-plus-jakarta-sans), sans-serif',
          fontSize: '14px',
          borderRadius: '10px',
        },
        duration: 3500,
      }}
    />
  );
}